// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";

var allLanguages = [
  "Go",
  "Rust",
  "Typescript",
  "OCaml",
  "C",
  "CSharp",
  "Php",
  "Python",
  "Other"
];

function extenstionToLanguage(ext) {
  switch (ext) {
    case "c" :
        return "C";
    case "cs" :
        return "CSharp";
    case "go" :
        return "Go";
    case "js" :
    case "mjs" :
        return "Javascript";
    case "ml" :
    case "mli" :
        return "OCaml";
    case "php" :
        return "Php";
    case "py" :
        return "Python";
    case "rs" :
        return "Rust";
    case "ts" :
        return "Typescript";
    default:
      return "Other";
  }
}

function getLanguageInfo(lang) {
  switch (lang) {
    case "Javascript" :
    case "Typescript" :
        return {
                name: "Typescript",
                ext: "ts",
                image: "badge-ts.webp",
                color: "#017ACC"
              };
    case "Php" :
        return {
                name: "PHP",
                ext: "php",
                image: "badge-php.webp",
                color: "#d6a400"
              };
    case "Python" :
        return {
                name: "Python",
                ext: "py",
                image: "badge-py.webp",
                color: "#00A4F6"
              };
    case "Rust" :
        return {
                name: "Rust",
                ext: "rs",
                image: "badge-rs.webp",
                color: "#d87b02"
              };
    case "Go" :
        return {
                name: "Go",
                ext: "go",
                image: "badge-go.webp",
                color: "#00ADD8"
              };
    case "C" :
        return {
                name: "C",
                ext: "c",
                image: "badge-c.webp",
                color: "#283591"
              };
    case "CSharp" :
        return {
                name: "C#",
                ext: "cs",
                image: "badge-cs.webp",
                color: "#9A4E96"
              };
    case "OCaml" :
        return {
                name: "OCaml",
                ext: "ml",
                image: "badge-ml.webp",
                color: "#F08E05"
              };
    case "Other" :
        return {
                name: "Other",
                ext: "",
                image: "badge-other.webp",
                color: "#00B344"
              };
    
  }
}

var InvalidDatestamp = /* @__PURE__ */Caml_exceptions.create("Project-BenfaerberBlog.InvalidDatestamp");

function parseProjectDate(datestamp) {
  var unpacked = Belt_Array.map(datestamp.split("-"), (function (t) {
          return Belt_Option.getWithDefault(Belt_Float.fromString(t), 0);
        }));
  if (unpacked.length !== 2) {
    throw {
          RE_EXN_ID: InvalidDatestamp,
          _1: "Bad",
          Error: new Error()
        };
  }
  var year = unpacked[0];
  var month = unpacked[1];
  return new Date(year, month - 1, 1);
}

function getProjectsFromFile(filename) {
  return fetch(filename).then(function (prim) {
                return prim.json();
              }).then(function (projects) {
              return Promise.resolve(Belt_Array.map(projects, (function (rp) {
                                var links = rp.links;
                                return {
                                        title: rp.title,
                                        description: rp.description,
                                        slug: rp.slug,
                                        language: extenstionToLanguage(rp.language),
                                        stack: Caml_option.nullable_to_opt(rp.stack),
                                        links: (links == null) ? undefined : Caml_option.some(links),
                                        date: parseProjectDate(rp.date)
                                      };
                              })));
            });
}

var version = String(Math.random());

function getProjects() {
  return getProjectsFromFile("/projects/projects.json?v=" + version);
}

function getSecretProjects() {
  return getProjectsFromFile("/projects/secret_projects.json?v=" + version);
}

function getAllProjects() {
  return Promise.all([
                getProjects(),
                getSecretProjects()
              ]).then(function (param) {
              return Promise.resolve(Belt_Array.concat(param[1], param[0]));
            });
}

var Api = {
  getProjectsFromFile: getProjectsFromFile,
  version: version,
  getProjects: getProjects,
  getSecretProjects: getSecretProjects,
  getAllProjects: getAllProjects
};

export {
  allLanguages ,
  extenstionToLanguage ,
  getLanguageInfo ,
  InvalidDatestamp ,
  parseProjectDate ,
  Api ,
}
/* version Not a pure module */
